module.exports = __webpack_public_path__ + "img/1557614105442983937.0f5efcd4.png";